export default "__VITE_ASSET__6b47d255__"